import { Keyboard } from '@capacitor/keyboard';
import { platform } from './identity';

export function createKeyboardController({ native = platform.isNative, keyboard = Keyboard, doc = typeof document !== 'undefined' ? document : undefined } = {}) {
  let state = Object.freeze({ visible: false, height: 0 });
  const listeners = new Set();
  let handles = [];
  let starting = null;

  const publish = (visible, height = 0) => {
    state = Object.freeze({ visible, height: visible ? Math.max(0, Number(height) || 0) : 0 });
    doc?.documentElement?.style?.setProperty('--app-keyboard-height', `${state.height}px`);
    doc?.documentElement?.classList?.toggle('app-keyboard-visible', state.visible);
    listeners.forEach((listener) => listener(state));
  };

  const start = () => {
    if (!native || starting || handles.length) return;
    starting = Promise.all([
      keyboard.addListener('keyboardWillShow', (info) => publish(true, info?.keyboardHeight)),
      keyboard.addListener('keyboardWillHide', () => publish(false, 0)),
    ]).then((values) => {
      starting = null;
      if (listeners.size) handles = values;
      else values.forEach((handle) => handle?.remove?.());
    });
  };

  return {
    getState: () => state,
    subscribe(listener) {
      listeners.add(listener);
      start();
      return () => {
        listeners.delete(listener);
        if (!listeners.size) {
          handles.forEach((handle) => handle?.remove?.());
          handles = [];
        }
      };
    },
  };
}

export const keyboard = createKeyboardController();
